module.exports = __webpack_public_path__ + "img/百香果8.2f33dc68.png";